import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrendingDownIcon, ClockIcon, SearchIcon, AlertTriangleIcon, ZapIcon, RocketIcon, BarChart3Icon, ShieldCheckIcon } from 'lucide-react';
export function MarketChallenges() {
  const {
    t
  } = useTranslation();
  return <section className="bg-white dark:bg-black py-20" data-id="element-826">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-827">
        <div className="text-center mb-16" data-id="element-828">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-829">
            {t('marketChallenges.title.prefix')}{' '}
            <span className="text-blue-600 dark:text-brand-green" data-id="element-830">
              {t('marketChallenges.title.highlight')}
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto" data-id="element-831">
            {t('marketChallenges.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-832">
          {[{
          value: '40%',
          description: t('marketChallenges.stats.verification'),
          icon: <ShieldCheckIcon className="h-6 w-6" data-id="element-833" />
        }, {
          value: '73%',
          description: t('marketChallenges.stats.manual'),
          icon: <ClockIcon className="h-6 w-6" data-id="element-834" />
        }, {
          value: '$3.2B',
          description: t('marketChallenges.stats.revenue'),
          icon: <TrendingDownIcon className="h-6 w-6" data-id="element-835" />
        }].map((stat, index) => <div key={index} className="bg-white dark:bg-gray-900 rounded-lg p-8 shadow-lg border border-gray-100 dark:border-gray-800" data-id="element-836">
              <div className="flex items-start" data-id="element-837">
                <div className="mr-4 p-3 bg-blue-50 dark:bg-brand-green/10 rounded-lg text-blue-600 dark:text-brand-green" data-id="element-838">
                  {stat.icon}
                </div>
                <div data-id="element-839">
                  <div className="text-4xl font-bold text-blue-600 dark:text-brand-green mb-2" data-id="element-840">
                    {stat.value}
                  </div>
                  <p className="text-gray-600 dark:text-gray-400 leading-tight" data-id="element-841">
                    {stat.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-842">
          <div className="bg-white dark:bg-gray-900 p-8 rounded-lg shadow-lg border border-gray-100 dark:border-gray-800" data-id="element-843">
            <div className="flex items-center mb-6" data-id="element-844">
              <div className="p-3 bg-red-50 dark:bg-red-500/10 rounded-lg mr-4" data-id="element-845">
                <SearchIcon className="h-6 w-6 text-red-600" data-id="element-846" />
              </div>
              <div data-id="element-847">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-848">
                  {t('marketChallenges.manual.title')}
                </h3>
                <p className="text-gray-600 dark:text-gray-400" data-id="element-849">
                  {t('marketChallenges.manual.subtitle')}
                </p>
              </div>
            </div>
            <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-850">
              {t('marketChallenges.manual.description')}
            </p>
            <div className="space-y-3" data-id="element-851">
              {t('marketChallenges.manual.issues', {
              returnObjects: true
            }).map((item, index) => <div key={index} className="flex items-center text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-500/10 rounded-lg p-3" data-id="element-852">
                  <AlertTriangleIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-853" />
                  <span data-id="element-854">{item}</span>
                </div>)}
            </div>
          </div>
          <div className="bg-blue-50 dark:bg-gray-900/50 p-8 rounded-lg shadow-lg border border-blue-100 dark:border-brand-green/20" data-id="element-855">
            <div className="flex items-center mb-6" data-id="element-856">
              <div className="p-3 bg-blue-100 dark:bg-brand-green/10 rounded-lg mr-4" data-id="element-857">
                <RocketIcon className="h-6 w-6 text-blue-600 dark:text-brand-green" data-id="element-858" />
              </div>
              <div data-id="element-859">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-860">
                  {t('marketChallenges.solution.title')}
                </h3>
                <p className="text-gray-600 dark:text-gray-400" data-id="element-861">
                  {t('marketChallenges.solution.subtitle')}
                </p>
              </div>
            </div>
            <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-862">
              {t('marketChallenges.solution.description')}
            </p>
            <div className="space-y-4" data-id="element-863">
              {t('marketChallenges.solution.features', {
              returnObjects: true
            }).map((feature, index) => <div key={index} className="group bg-white dark:bg-gray-900 p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-864">
                  <div className="flex items-start" data-id="element-865">
                    <div className="p-2 bg-blue-50 dark:bg-brand-green/10 rounded-lg mr-3 text-blue-600 dark:text-brand-green" data-id="element-866">
                      {index === 0 ? <ZapIcon className="h-5 w-5" data-id="element-867" /> : index === 1 ? <BarChart3Icon className="h-5 w-5" data-id="element-868" /> : <ShieldCheckIcon className="h-5 w-5" data-id="element-869" />}
                    </div>
                    <div data-id="element-870">
                      <h4 className="font-medium text-blue-600 dark:text-brand-green mb-1" data-id="element-871">
                        {feature.title}
                      </h4>
                      <p className="text-gray-600 dark:text-gray-400 text-sm" data-id="element-872">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}